import {from, throwError} from 'rxjs';
import {map, catchError} from 'rxjs/operators';
import axios from 'axios';

export const GOOGLE_BOOKS_API_WITH_VOLUMES =
  'https://www.googleapis.com/books/v1/volumes';

export const getBooks$ = (option, value, startIndex, maxLength) => {
  if ((startIndex, maxLength)) {
    return from(
      axios.get(
        `${GOOGLE_BOOKS_API_WITH_VOLUMES}?filter=${option}&q=${value}&startIndex=${startIndex}&maxLength=${maxLength}`,
      ),
    ).pipe(
      map((res) => res),
      catchError((err) => throwError(err)),
    );
  }
  return from(
    axios.get(`${GOOGLE_BOOKS_API_WITH_VOLUMES}?filter=${option}&q=${value}`),
  ).pipe(
    map((res) => res),
    catchError((err) => throwError(err)),
  );
};
